import { ModulesManagerService } from "../Module/modules-manager.service"

export class Notification {
    private hydrated: boolean = false
    private quantity = 0
    private askId = -1
    private parent = ""
    constructor(private manager : ModulesManagerService,Data= null){
        this.manager = manager
        if(Data!=null) this.Hydrate(Data)
    }

    async Hydrate(Data){
        this.hydrated = true
        for(const[key, propertie] of Object.entries(Data))
            this[this.manager.Tool.minimilizeFirstChar(key)] = propertie    
        return this
    }

    get AskId(){
        return this.askId
    }

    get Parent(){
        return this.parent
    }

    get Quantity(){
        return this.quantity
    }
}
